export const formatRows = (listaItems) =>
  listaItems.map((item) => ({
    id: item.id || "Id no disponible",
    mod_descripcion: item.mod_descripcion || "Modelo no disponible",
  }));
